import getLookerUrl, { Metric } from '../repository/getLookerUrl'
import getPartner from '../../Account/repository/getPartner'

const useEarnings = () => {
  const fetchLookerUrl = async (metric: Metric) => getLookerUrl(metric)
  const fetchDeductionsUrl = async () => fetchLookerUrl('deductions')
  const fetchLedgerUrl = async () => fetchLookerUrl('ledger')

  const fetchPaymentsUrl = async (): Promise<string> => {
    const { tipalti_payments_url: tipaltiPaymentsUrl, error } =
      await getPartner()

    return error ? '' : tipaltiPaymentsUrl
  }

  return {
    fetchDeductionsUrl,
    fetchLedgerUrl,
    fetchPaymentsUrl
  }
}

export default useEarnings
